import { AbstractModel, DateUtil, isNullOrUndefined, ObjectConstants } from '@uzurv/core';
import { autoserialize, autoserializeAs, Deserialize, inheritSerialization } from 'cerialize';
import { OperationsAlertRideInfo } from './operations-alert-ride-info';
import { OperationsAlertType } from './operations-alert-type';

@inheritSerialization(AbstractModel)
export class OperationsAlertInfo extends AbstractModel {
  @autoserialize
  objectId: number;

  @autoserializeAs(OperationsAlertType)
  operationsAlertType: OperationsAlertType;

  @autoserializeAs(OperationsAlertRideInfo)
  operationsAlertObjectInfo: OperationsAlertRideInfo;

  @autoserialize
  assigned: boolean;

  @autoserializeAs(Date)
  assignedDate: Date;

  @autoserialize
  assignedTo: string;

  @autoserialize
  assignedToUserId: number;

  @autoserialize
  assignedBy: string;

  @autoserialize
  resolved: boolean;

  @autoserializeAs(Date)
  resolvedDate: Date;

  @autoserialize
  resolvedBy: string;

  @autoserialize
  resolutionComments: string;

  static OnSerialized(instance: OperationsAlertInfo, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.assignedDate)) {
      json.assignedDate = DateUtil.serializeDate(instance.assignedDate);
    }

    if (!isNullOrUndefined(instance.resolvedDate)) {
      json.resolvedDate = DateUtil.serializeDate(instance.resolvedDate);
    }
  }

  static OnDeserialized(instance: OperationsAlertInfo, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['createdDate'])) {
      instance.createdDate = DateUtil.deserializeDate(json['createdDate']);
    }

    if (!isNullOrUndefined(json['modifiedDate'])) {
      instance.modifiedDate = DateUtil.deserializeDate(json['modifiedDate']);
    }

    if (!isNullOrUndefined(json['assignedDate'])) {
      instance.assignedDate = DateUtil.deserializeDate(json['assignedDate']);
    }

    if (!isNullOrUndefined(json['resolvedDate'])) {
      instance.resolvedDate = DateUtil.deserializeDate(json['resolvedDate']);
    }

    if (
      instance.operationsAlertType.objectName === ObjectConstants.RESERVATION ||
      instance.operationsAlertType.objectName === ObjectConstants.RIDE_REQUEST
    ) {
      instance.operationsAlertObjectInfo = Deserialize(json['operationsAlertObjectInfo'], OperationsAlertRideInfo);
    }
  }
}
